<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Ordenes</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="descargarCsv" fill="outline" v-if="yo.rol=='administrador'">
          <i class="icon ion-ios-download"></i>&nbsp;CSV
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <ion-progress-bar type="indeterminate" v-if="cargando"></ion-progress-bar>
  </ion-header>
  <ion-content class="content">
    <ion-row>
      <ion-col class="ion-no-padding" size-xs="12" size-sm="5" size-md="4" size-lg="3">
        <ion-row>
          <ion-col size-xs="12">
            <ion-item>
              <ion-label position="floating">Desde fecha</ion-label>
              <ion-input type="date" debounce="100" :value="desdeFecha" v-on:ionChange="set('desdeFecha',$event.detail.value)"></ion-input>
            </ion-item>
          </ion-col>
          <ion-col size-xs="12">
            <ion-item>
              <ion-label position="floating">Hasta fecha</ion-label>
              <ion-input type="date" debounce="100" :value="hastaFecha" v-on:ionChange="set('hastaFecha',$event.detail.value)"></ion-input>
              <ion-button slot="end" fill="solid" size="medium" color="light" @click="obtener" :disabled="cargando">
                <i class="icon ion-ios-search"></i>&nbsp;Buscar
              </ion-button>
            </ion-item>
          </ion-col>
          <ion-col size="12">
            <ion-searchbar placeholder="Filtrar por empleado, cliente o equipo" :value="filtro" v-on:ionChange="filtrar($event.detail.value)" debounce="200"></ion-searchbar>
          </ion-col>
          <ion-col size="12" class="ion-no-padding" v-if="proyectos.length>0">
            <ion-card>
              <ion-list>
                <ion-item @click="proyectoSeleccionado='';filtrar(filtro)">
                  <ion-label>
                    <h2>Ver TODOS los proyectos</h2>
                  </ion-label>
                  <ion-checkbox slot="end" :checked="proyectoSeleccionado==''"></ion-checkbox>
                </ion-item>
                <ion-item v-for="p in proyectos" :key="p._id" @click="proyectoSeleccionado=p._id;filtrar(filtro)">
                  <ion-label text-wrap>
                    <h2>{{p.nombre}}</h2>
                    <p>{{p.nombreCliente}}</p>
                  </ion-label>
                  <ion-checkbox slot="end" :checked="proyectoSeleccionado==p._id"></ion-checkbox>
                </ion-item>
              </ion-list>
            </ion-card>
          </ion-col>
          <ion-col size="12" v-if="yo.rol=='administrador'" class="ion-padding-horizontal">
            <ion-button expand="block" fill="outline" :disabled="cargando" size="small" @click="descargarTodos">Descargar todos PDF</ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col class="ion-no-padding" size-xs="12" size-sm="7" size-md="8" size-lg="9">
        <ion-list v-if="ordenes.length>0">
          <ion-item lines="none">
            <ion-label color="medium">
              <h2>Resultados ({{ordenes.length}})</h2>
            </ion-label>
          </ion-item>
          <div v-if="esMovil">
            <ion-item-sliding v-for="o in ordenes" :key="o._id">
              <ion-item>
                <ion-note slot="start" :color="o.terminada?'success':'warning'" @click="ver(o._id)">
                  <i :class="'icon ion-ios-'+iconoEstado(o)"></i>
                </ion-note>
                <ion-label @click="ver(o._id)" text-wrap>
                  <h2 v-if="o.cliente">{{o.folio}} {{o.cliente.alias || o.cliente.nombre}}, {{o.fechaCreada | moment('MMM DD')}} <span v-if="o.branding">{{o.branding.alias||o.branding.nombre}}</span></h2>
                  <p v-if="o.equipo">{{o.equipo.tipo}}, {{o.equipo.marca}} {{o.equipo.modelo}}, SN:{{o.equipo.sn}}<span v-if="o.imagenes && o.imagenes.length>0">,&nbsp;{{o.imagenes.length}}<i class="icon ion-ios-images icon-sm"></i></span></p>
                  <p v-if="o.equipo">{{o.equipo.area}} <span v-if="o.equipo.area!=o.equipo.subarea">{{o.equipo.subarea}}</span></p>
                  <p v-if="o.fechaTerminada">Terminada el {{o.fechaTerminada | moment('MMM DD')}}</p>
                </ion-label>
                <ion-button slot="end" @click="verPDF(o)" fill="clear" color="medium">
                  <i class="icon ion-ios-document"></i>
                </ion-button>
              </ion-item>
              <ion-item-options slot="end">
                <ion-item-option color="danger" v-if="yo.permiso_cancelaOrdenesServicio" v-on:click="eliminar(o)">
                  <i class="icon ion-ios-trash"></i>
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </div>
          <table v-else id="listaOrdenes">
            <thead>
              <tr>
                <th @click="ordenarPor('fechaCreada')">Fecha creada</th>
                <th @click="ordenarPor('folio')">Folio</th>
                <th @click="ordenarPor('nombreBranding')">Branding</th>
                <th @click="ordenarPor('nombreCliente')">Cliente</th>
                <th @click="ordenarPor('nombreEquipo')">Equipo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="o in ordenes" :key="o._id" @click="clog(o)">
                <td @click="eliminar(o)">{{o.fechaCreada | moment('MMM DD')}}</td>
                <td>
                  <ion-button size="small" fill="solid" color="secondary" @click="$router.push('/ordenes/'+o._id)">{{o.folio || o.nombre}}</ion-button>
                </td>
                <td>{{(o.branding||{}).nombre}}</td>
                <td>{{(o.cliente||{}).nombre}}</td>
                <td>{{nombreEquipo(o.equipo)}}</td>
                <td class="ion-text-center">
                  <ion-button color="secondary" fill="clear" @click="verPDF(o)">
                    <i class="icon ion-ios-document"></i>
                  </ion-button>
                </td>
              </tr>
            </tbody>
          </table>
        </ion-list>
        <ion-item v-else>
          <ion-label color="danger" class="ion-text-center" text-wrap>
            <h2>Esta lista está vacía</h2>
            <p>Amplía tus parámetros de búsqueda</p>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="primary" @click="ver('0')">
        <i class="icon icon-lg ion-ios-add"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
</ion-app>
</template>
<style>
table#listaOrdenes {
  width: 100%;
  overflow-x: auto;
}

table#listaOrdenes th,
table#listaOrdenes td {
  padding-bottom: 12px;
  padding-right: 6px;
  text-align: left !important;
  font-family: 'Calibri', 'Ubuntu', sans-serif;
}
</style>
<script>
import Api from '@/components/Api/Api'
import Docxgen from '@/models/Docxgen'
const desdeFechaDefault = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 15)).toISOString().substring(0, 10)
const hastaFechaDefault = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 1)).toISOString().substring(0, 10)
export default {
  name: 'OrdenesLista',
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      cargando: true,
      esMovil: Api.esMovil(),
      desdeFecha: Api.fetchLocal('cmms.ordenesListaDesdeFecha') || desdeFechaDefault,
      hastaFecha: Api.fetchLocal('cmms.ordenesListaHastaFecha') || hastaFechaDefault,
      filtro: Api.fetchLocal('cmms.ordenesListaQueryFiltro') || '',
      ordenesTodas: [],
      ordenes: [],
      usuariosIndices: {},
      clientesIndices: {},
      equiposIndices: {},
      brandingsIndices: {},
      proyectosTodos: [],
      proyectos: [],
      proyectoSeleccionado: '',
      sentido: 1
    }
  },
  async mounted() {
    await this.obtenerCatalogos()
    this.obtener()
  },
  watch: {
    desdeFecha: function(a) {
      Api.saveLocal('cmms.ordenesListaDesdeFecha', a)
    },
    hastaFecha: function(a) {
      Api.saveLocal('cmms.ordenesListaHastaFecha', a)
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    iconoEstado(orden) {
      return (orden.terminada == true) ?
        'checkmark-circle-outline' : 'information-circle-outline'
    },
    ver(id) {
      this.$router.push('/ordenes/' + id)
    },
    set(campo, valor) {
      this[campo] = valor
      console.log("set", campo, valor)
    },
    clog(obj) {
      console.log(obj)
    },
    nombreEquipo(eq = {}) {
      let str = ''
      for (let prop of ['nombre', 'marca', 'modelo', 'sn', 'area']) {
        str += (eq[prop] || '') + ' '
      }
      return str
    },
    async obtenerCatalogos() {
      //
      try {
        const usuarios = await Api.get('directorio')
        for (let u of usuarios)
          this.usuariosIndices[u._id] = u
        const equipos = await Api.get('equipo')
        for (let e of equipos)
          this.equiposIndices[e._id] = e
        const clientes = await Api.get('cliente')
        for (let c of clientes)
          this.clientesIndices[c._id] = c
        const brandings = await Api.get('branding')
        for (let b of brandings)
          this.brandingsIndices[b._id] = b
        this.proyectosTodos = await Api.get('proyectoorden')
        console.log("catalogos?", {
          usuarios: usuarios.length,
          equipos: equipos.length,
          clientes: clientes.length,
          brandings: brandings.length
        })
      } catch (e) {
        toast("No se pudieron obtener los catálogos")
        console.error(e)
      }
      return true
    },
    async obtener() {
      this.cargando = true
      let filtros = [
        'fecha,gte,' + new Date(this.desdeFecha).getTime(),
        'fecha,lt,' + new Date(this.hastaFecha).getTime()
      ]
      const clientesIndices = this.clientesIndices
      const usuariosIndices = this.usuariosIndices
      const equiposIndices = this.equiposIndices
      const brandingsIndices = this.brandingsIndices
      const nombreEquipo = this.nombreEquipo
      try {
        this.ordenesTodas = (await Api.find('ordenservicio', filtros, {
            sort: ['fecha,-1']
          }))
          .map(o => {
            o.cliente = clientesIndices[o.idCliente] || {}
            o.nombreCliente = (o.cliente.nombre || '').toUpperCase()
            o.autor = usuariosIndices[o.idAutor] || {}
            o.nombreAutor = (o.autor.nombre || '').toUpperCase()
            o.branding = brandingsIndices[o.idBranding] || {}
            o.nombreBranding = (o.branding.nombre || '').toUpperCase()
            o.equipo = equiposIndices[o.idEquipo] || {}
            o.nombreEquipo = (nombreEquipo(o.equipo) || '').toUpperCase()
            return o
          })
        console.log("obtener", this.ordenesTodas, filtros)
        this.filtrar(this.filtro)
      } catch (e) {
        console.error(e)
        toast("No se pudieron cargar las órdenes", null, 'danger')
      }
      const mapaClientes = [...new Set(this.ordenesTodas.map(o => o.idCliente))]
      this.proyectos = this.proyectosTodos
        .filter(p => mapaClientes.indexOf(p.idCliente) >= 0)
        .map(p => {
          p.nombreCliente = (clientesIndices[p.idCliente] || {}).nombre
          return p
        })
      this.cargando = false
    },
    filtrar(str) {
      str = (str || '').toUpperCase()
      this.filtro = str
      Api.saveLocal('cmms.ordenesListaQueryFiltro', str)
      let ordenes = []
      if (str == '')
        ordenes = JSON.parse(JSON.stringify(this.ordenesTodas))
      else {
        ordenes = this.ordenesTodas
          .filter(o => {
            let strMaestra = '' + o.folio
            if (o.cliente)
              for (let prop of ['alias', 'nombre'])
                strMaestra += (o.cliente[prop] || '').toUpperCase()
            if (o.equipo)
              for (let prop of ['alias', 'nombre', 'marca', 'modelo', 'sn'])
                strMaestra += (o.equipo[prop] || '').toUpperCase()
            return strMaestra.indexOf(str) >= 0
          })
      }
      const proyectoSeleccionado = this.proyectoSeleccionado
      ordenes = ordenes
        .filter(o => o.idProyecto == proyectoSeleccionado || proyectoSeleccionado == '')
      console.log("ordenes filtradas?", ordenes.length)
      this.ordenes = ordenes
    },
    ordenarPor(prop) {
      this.sentido = this.sentido * (-1)
      const sentido = this.sentido
      this.ordenes = this.ordenes
        .sort((a, b) => a[prop] > b[prop] ? sentido : sentido * -1)
    },
    download(filename, text, crudo) {
      var element = document.createElement('a');
      if (!crudo)
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      else
        element.setAttribute('href', text);
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    descargarCsv() {
      let txt = 'Fecha inicio,Fecha fin,Folio,Cliente,Equipo,Diagnostico\n'
      let ordenesParaCsv = JSON.parse(JSON.stringify(this.ordenes)).reverse()
      for (let o of ordenesParaCsv) {
        let renglon = ''
        renglon += this.$options.filters.moment(o.fechaCreada, 'YYYY-MM-DD') + ','
        if (o.fechaTerminada)
          renglon += this.$options.filters.moment(o.fechaTerminada, 'YYYY-MM-DD') + ','
        else renglon += ','
        renglon += (o.folio || o._id) + ','
        renglon += (o.cliente || {}).nombre.replace(/,/g, ' ') + ','
        renglon += (o.equipo || {}).tipo + ' ' + ((o.equipo || {}).nombre || (o.equipo || {}).marca) + ' NS ' + (o.equipo || {}).sn + ','
        renglon += (o.diagnostico || o.objetivo || '')
          .replace(/,/g, ' ')
          .replace(/\n/g, '') + ','
        txt += renglon + '\n'
      }
      console.log("csv?", txt.length)
      this.download('ordenes.csv', txt)
    },
    async crearPDF(orden) {
      this.cargando = true
      console.log("obtenerPDF", orden)
      let url = 'http://www.africau.edu/images/default/sample.pdf'
      let vm = this
      let soap = [{
          label: 'Falla reportada',
          name: 'fallaReportada'
        },
        {
          label: 'Falla encontrada',
          name: 'fallaEncontrada'
        },
        {
          label: 'Diagnóstico (Reporte técnico)',
          name: 'diagnostico',
        },
        {
          label: 'Plan de acción (Notas)',
          name: 'planDeAccion'
        },
        {
          label: 'Condiciones de recepción de equipo',
          name: 'condicionesRecepcion'
        },
        {
          label: 'Condiciones de entrega',
          name: 'condicionesEntrega'
        }
      ]
      return new Promise(async (resolve, reject) => {
        try {
          let branding = orden.branding || await Api.get('branding', orden.idBranding)
          let anularTimeout = true
          let plantilladocx = (await Api.get('brandingplantilladocx', branding._id, anularTimeout)).data
          // Procesar
          if (typeof orden.fechaCreada != 'number')
            orden.fechaCreada = new Date(orden.fechaCreada).getTime()
          for (let prop in orden) {
            if (prop.startsWith('fecha'))
              orden[prop] = this.$options.filters.moment(orden[prop], 'YYYY-MM-DD HH:mm')
            if (!isNaN(orden[prop]) && prop != 'folio')
              orden[prop] = this.$options.filters.currency(orden[prop], '')
          }
          if (!orden.equipo && orden.idEquipo && orden.idEquipo != '')
            orden.equipo = await Api.get('equipo', orden.idEquipo)
          orden.autor = await Api.get('directorio', orden.idAutor)
          orden.cliente = await Api.get('cliente', orden.idCliente)
          // Enmascarar los datos no existentes
          for (let campo of soap)
            if (!orden[campo.name])
              orden[campo.name] = ''
          for (let campo of ['alias', 'nombre', 'marca', 'modelo', 'sn'])
            if (!orden.equipo[campo])
              orden.equipo[campo] = ''
          for (let campo of ['alias', 'telefono', 'telefonos', 'email', 'rfc', 'direccion', 'representante'])
            if (!orden.cliente[campo])
              orden.cliente[campo] = ''
          // Enmascarar los costos no existentes
          console.log("Enmascarando costos", orden.costos.length, orden.costos)
          if (orden.costos.length == 0 || typeof orden.costos != 'object') {
            orden.costos = [{
              cantidad: '',
              concepto: 'Ninguna',
              precioUnitario: ''
            }]
          }
          //
          console.log("obtenerPDF?", orden)
          let docx = await Docxgen.docxSimple(orden, plantilladocx, true)
          url = 'data:application/pdf;base64,' + (await Api.libreofficetopdf(docx)).data.data
          console.log("docx?", docx.length, url.length, url.substring(0, 50))
          vm.cargando = false
          vm.$forceUpdate()
          resolve(url)
        } catch (e) {
          toast("No se pudo obtener el PDF")
          console.error("EPDF", e)
          reject(e)
        }
      })
    },
    async verPDF(orden, regenerar = false) {
      toast("Obteniendo PDF de orden " + (orden.folio || orden.nombre), null, 'tertiary')
      let data
      try {
        if (regenerar)
          throw new Error('Regenerando manualmente')
        data = (await Api.get('ordenserviciopdf', orden._id)).data
        console.log("Recuperado PDF", data.length)
      } catch (e) {
        console.error(e)
        data = await this.crearPDF(orden)
        console.log("documento nuevo?", data.length)
        await Api.save('ordenserviciopdf', {
          _id: orden._id,
          data
        })
      }
      this.download('OS ' + (orden.folio || orden._id) + '.pdf', data, true)
      return true
    },
    async descargarTodos() {
      alert("Se descargarán todos los PDF de esta lista. Su navegador podría preguntarle sobre descargar múltiples archivos. ")
      for (let o of this.ordenes)
        await this.verPDF(o)
    },
    async eliminar(o) {
      if (true == confirm('Desea eliminar esta orden? Esto no se puede deshacer')) {
        await Api.delete('ordenservicio', o._id)
        toast("Eliminada")
        await Api.wait()
        this.obtener()
      }
    }
  }
}
</script>
